<template>
    <div v-if="youtubeVideos.length > 0" class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
        <div
            v-for="video in youtubeVideos"
            :key="video.meta.id.videoId"
            class="flex flex-col bg-dashboard-primary rounded-xl hover:shadow-md hover:scale-105 duration-300 overflow-hidden"
        >
            <a :href="'https://www.youtube.com/watch?v=' + video.meta.id.videoId" target="_blank" class="flex flex-col w-full">
                <div class="relative w-full aspect-w-16 aspect-h-9">
                    <img v-if="video.meta.snippet.thumbnails" :src="video.meta.snippet.thumbnails.high.url" alt="Video Thumbnail" class="object-cover h-full w-full" />
                </div>

                <div class="flex flex-col gap-4 p-4">
                    <p class="text-dashboard-primary-grey text-sm">
                        {{ formatDateByRegion($moment(video.meta.snippet.publishedAt)) }}
                    </p>

                    <p class="font-bold text-black text-base">
                        {{ video.meta.snippet.title }}
                    </p>
                </div>
            </a>
        </div>
    </div>
    <div v-else>
        <no-item-found
            :item-name="$t('matching_videos')"
            :link="'https://www.youtube.com/channel/' + (region === 'de' ? '@hkcm' : '@HKCM_GLOBAL')"
            :link-external="true"
            icon="fi fi-brands-youtube"
            class="w-full"
        />
    </div>
</template>

<script setup>
import { defineProps, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { formatDateByRegion } from '../../helpers.js';
import NoItemFound from './noItemFound.vue';

const props = defineProps({
    productGroupName: Object | String
});
const store = useStore();
const youtubeVideos = ref([]);
const region = window.meta.region_configuration.region;
const loading = ref(true);

const getYouTubeVideos = () => {
    if (!props.productGroupName) {
        return;
    }

    const videos = store.getters['social_media/getByKey'](props.productGroupName.de);

    if (videos.length > 0) {
        youtubeVideos.value = videos.filter((video) => video.region === region);
        loading.value = false;

        return;
    }

    store
        .dispatch('social_media/youtube', {
            params: {
                query: props.productGroupName,
                key: props.productGroupName.de
            }
        })
        .then(() => {
            youtubeVideos.value = store.getters['social_media/getByKey'](props.productGroupName.de).filter((video) => video.region === region);

            loading.value = false;
        });
};

onMounted(() => {
    getYouTubeVideos();
});
</script>
